import { render, staticRenderFns } from "./MessagesComponent.vue?vue&type=template&id=f338308e&scoped=true&"
import script from "./MessagesComponent.vue?vue&type=script&lang=js&"
export * from "./MessagesComponent.vue?vue&type=script&lang=js&"
import style0 from "./MessagesComponent.vue?vue&type=style&index=0&id=f338308e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f338308e",
  null
  
)

export default component.exports